<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="help-us-kiddies">
<h1>Help Us, Kiddies</h1>
<p style="text-indent:0px;">Why not believe in pixies and fairies,</p>
<p style="text-indent:0px;">Of course unicorns too?</p>
<p style="text-indent:0px;">They have been here for centuries,</p>
<p style="text-indent:0px;">Just search your garden for a clue.</p><br/>
<p style="text-indent:0px;">Moonlight, blue it beams down,</p>
<p style="text-indent:0px;">As little elves dance for joy.</p>
<p style="text-indent:0px;">There are even special hidden towns,</p>
<p style="text-indent:0px;">For every believing girl and boy.</p><br/>
<p style="text-indent:0px;">Clovers with four leaves,</p>
<p style="text-indent:0px;">Will bring you lifelong luck.</p>
<p style="text-indent:0px;">If you find one in amongst the trees,</p>
<p style="text-indent:0px;">Carefully pick it up.</p><br/>
<p style="text-indent:0px;">Believing though it is a must,</p>
<p style="text-indent:0px;">If you seek these magical scenes!</p>
<p style="text-indent:0px;">I once sneezed on fairy dust,</p>
<p style="text-indent:0px;">They are real, so it seems!</p><br/>
<p style="text-indent:0px;">Invisible to the grumpy mind,</p>
<p style="text-indent:0px;">A whole world of wonder for you awaits!</p>
<p style="text-indent:0px;">Deep in moss-covered forests you’ll find,</p>
<p style="text-indent:0px;">Smiling creatures in ecstatic states!</p><br/>
<p style="text-indent:0px;">Keep on saying that you believe,</p>
<p style="text-indent:0px;">Please don’t make your new friends cry!</p>
<p style="text-indent:0px;">For should you forget they do grieve,</p>
<p style="text-indent:0px;">They grieve until they die.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?1fe56f5c